// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { DeleteTasksConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';
import { WorkflowS } from '../../../../Service/WorkflowS';
import { getReportExecutionState } from './reportExecutionState';

const DeleteTasksReport: FC<ProcedureReportProps> = ({ report, config }) => {
  const { removeOnlyUnfinished } = config as DeleteTasksConfigDTO;
  const executionState = getReportExecutionState(report?.executionStatus);
  const taskDescription = `Alle ${removeOnlyUnfinished ? 'nicht erledigten ' : ''}Aufgaben`;

  return (
    <Text>
      {executionState === 'SKIPPED' ? 'Löschen von ' : ''}
      {taskDescription}{' '}
      {executionState === 'COMPLETED' && 'wurden gelöscht.'}
      {executionState === 'PLANNED' && 'werden gelöscht.'}
      {executionState === 'SKIPPED' && 'wurde übersprungen.'}
      {executionState === 'NOT_EXECUTED' && 'wurden nicht gelöscht.'}
      {WorkflowS.getWorkflowErrorDescription(report)}
    </Text>
  );
};

export default DeleteTasksReport;
